// extracted by mini-css-extract-plugin
module.exports = {"content":"mI1z06aEi7-qRCBkjhQdG","body":"_3JFohs_Zunpm_jG8heGYgm"};